// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d51d42d","732":"bd93591c","977":"cad87b25"}[chunkId] + ".chunk.js";
};